import type { AnalyticsClient } from './index'
import type {
    RawPlaygamaCTREvent,
    RawPlaygamaEvent,
    RawPlaygamaSurveyGameEvent,
    RawPlaygamaUIEvent,
    RawRumMetricData,
    RumMetricResult,
} from './types'

export class MockAnalytics implements AnalyticsClient {
    log(_event: RawPlaygamaEvent) {}

    logAndFlush(_event: RawPlaygamaEvent) {}

    logUiEvent(_event: RawPlaygamaUIEvent) {}

    logCTREvent(_event: RawPlaygamaCTREvent) {}

    logSurveyEvent(_event: RawPlaygamaSurveyGameEvent) {}

    startRumEvent(_metric: RawRumMetricData) {
        return (_status: RumMetricResult) => {}
    }

    registerPageHideFallbackEvent(_event: RawPlaygamaEvent) {
        return () => {}
    }
}
